
import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';
import {CREATE_QNA} from "../actions/type";

export const initialState = {
  token: '',
  userInfo: {} ,
  isProcessing: false,
  statusCode: null,
};



